module.exports = __webpack_public_path__ + "img/innovacion.10588fe6.png";